const fields = {
  ok: "تایید",
  next: "بعد",
  back: "قبل",
  create: "ایجاد",
  update: "بروزرسانی",
  edit: "ویرایش",
  selectAll: "انتخاب همه",
  selected: "رکورد انتخاب شده {selected}",
  filtered: "فیلتر شده {filtered}",
  rmFilters: "پاک کردن فیلترها",
  showFilters: "نمایش فیلترها",
  hideFilters: "مخفی کردن فیلترها",
  refresh: "تازه سازی",
  delete: "حذف",
  ignore: "فعلا نه",
  deleteMessage: "آیا از حدف این مورد اطمینان دارید؟",
  do: "بله",
  dont: "خیر",
  description: "توضیحات",
  call_me: "با شما تماس گرفته شود؟",
  number: "تعداد",
  price: "قیمت",

  title: "عنوان",
  alias: "عنوان لاتین",
  city: "شهر",
  state: "استان",
  manager: "مدیر",
  firstname: "نام",
  lastname: "نام خانوادگی",
  national_code: "کد ملی",
  birth_date: "تاریخ تولد",
  medical_number: "شماره نظام پزشکی",
  specialist: "تخصص",
  gender: "جنسیت",
  skinColor: "رنگ پوست",
  man: "آقا",
  woman: "خانم",
  email: "ایمیل",
  address: "آدرس",
  cellphone: "تلفن همراه",
  generalDentist: "دندانپزشک عمومی",
  restorativeDentistry: "متخصص ترمیم",
  prosthodontics: "متخصص پروتز",
  orthodontics: "متخصص ارتودنسی",
  activity: "وضعیت",

  //Skin Colors
  lightSkin: "روشن",
  mediumSkin: "گندمی",
  darkSkin: "تیره",
  veryDarkSkin: "بسیار تیره",
};
export default fields;
